import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { DefaultView as View } from 'turing-uiux';
import ErrorBoundary from 'components/blocks/ErrorBoundary';
import { useVisibleRoutes } from 'routes/routesOnNav';
import { clearUserToken } from 'services/token';
import { googleLogout } from '@react-oauth/google';
import { useDispatch, useSelector } from 'react-redux';
import { useGetCurrentProfile } from '../../../query/user';
import { setIsLoggedIn } from '../../../store/actions/auth';
import { getIsUserLoggedIn } from '../../../store/selectors/auth';
import { user as userImage } from 'assets/img';
import BugReportButton from 'components/blocks/BugReportButton';
import BugReportForm from 'components/blocks/BugFeatureReportForm';

const DefaultView = props => {
  const isLoggedIn = useSelector(getIsUserLoggedIn);
  const routesToRender = useVisibleRoutes();
  const { data: user } = useGetCurrentProfile();
  const dispatch = useDispatch();

  return (
    <ErrorBoundary>
      <View
        appTitle={props.appTitle}
        menuitems={routesToRender}
        notificationsPanel={props.notificationsPanel}
        rightDrawer={props.rightDrawer}
        signOut={() => {
          clearUserToken();
          googleLogout();
          dispatch(setIsLoggedIn(false));
          props.history.push('/auth/sign-in');
        }} // eslint-disable-line react/jsx-handler-names
        statusPanel={props.statusPanel}
        topPanel={props.topPanel}
        userAvatar={user?.avatar || userImage}
        userName={user?.fullName}
      >
        {isLoggedIn ? (
          <>
            {props.children}
            <BugReportButton />
            <BugReportForm />
          </>
        ) : null}
      </View>
    </ErrorBoundary>
  );
};

DefaultView.defaultProps = {
  appTitle: 'ECS',
  notificationsPanel: '',
  rightDrawer: '',
  statusPanel: '',
  topPanel: '',
  userName: 'Admin',
};

DefaultView.propTypes = {
  appTitle: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  location: PropTypes.object.isRequired,
  notificationsPanel: PropTypes.string,
  rightDrawer: PropTypes.string,
  statusPanel: PropTypes.string,
  topPanel: PropTypes.string,
};

const DefaultViewWithRouter = withRouter(DefaultView);

export default DefaultViewWithRouter;
